import { IAccountsProduct, IPolicy } from "config/types";
import { logout } from "store/actions/authentication";
import { getDashboardData } from "store/actions/dashboard";
import { getPendingPolicy } from "store/actions/pendingPolicy";
import { toFixed } from "utils/toFixed";

import { createReducer } from "@reduxjs/toolkit";

export interface IPendingPolicyState extends Omit<IPolicy, "classification" | "lapsesAt"> {
  accountsProduct: IAccountsProduct;
}

const defaultState: IPendingPolicyState = {
  id: "",
  status: "",
  amount: 0,
  termDuration: 0,
  termUnit: "month",
  increaseCoverageAmountAllowed: false,
  insuredsAgeAtTerm: 0,
  premiums: [],
  product: undefined,
  effectiveAt: "",
  pausedAt: "",
  terminatesAt: "",
  effectiveUntil: "",
  documents: [],
  accountsProduct: {
    id: "",
    amount: 0,
    billingFrequency: "monthly",
    nextPayment: {
      date: "",
      estimated: false,
      invoiceId: "",
    },
  },
};

const pendingPolicy = createReducer(defaultState, builder => {
  builder.addCase(getPendingPolicy.fulfilled, (state, action) => {
    const pendingPolicy = action.payload;
    const defaultAccountsProduct = pendingPolicy?.accountsProduct || state.accountsProduct;

    const accountsProductAmount = toFixed(defaultAccountsProduct?.amount || 0);
    const accountsProduct = { ...defaultAccountsProduct, amount: accountsProductAmount };

    Object.assign(state, pendingPolicy, { accountsProduct });
  });
  builder.addCase(getDashboardData.fulfilled, (state, action) => {
    const pendingPolicy = action.payload?.pendingPolicy || defaultState;
    const accountsProductPayload = pendingPolicy?.accountsProduct || state.accountsProduct;
    const accountsProductAmount = toFixed(
      accountsProductPayload?.amount || state.accountsProduct.amount
    );
    const accountsProduct = {
      ...state.accountsProduct,
      ...accountsProductPayload,
      amount: accountsProductAmount,
    };

    Object.assign(state, pendingPolicy, { accountsProduct });
  });
  builder.addCase(logout, () => defaultState);
});

export default pendingPolicy;
